import React from "react";
import { Form } from "antd";
import { noop } from "lodash";

import { DATE_DATA_FORMAT, DATE_FORMAT } from "../../../../utils/date";
import { dateParser } from "../utils";
import { DatePicker } from "@tailormed/common-client/component/DatePicker";

export default ({
  onChange = noop,
  required = false,
  placeholder = DATE_FORMAT,
  defaultDate = null,
  disabledDate = null,
  disabled,
  rules = [],
  ...props
}) => (
  <Form.Item //
    rules={[{ type: "date" }, { required }, ...rules]}
    getValueProps={dateParser}
    getValueFromEvent={(momentValue) => momentValue?.format(DATE_DATA_FORMAT)}
    {...props}
  >
    <DatePicker
      onChange={onChange}
      placeholder={placeholder}
      defaultPickerValue={defaultDate}
      disabledDate={disabledDate}
      disabled={disabled}
    />
  </Form.Item>
);
